<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="用户ID" prop="userId"><el-input v-model="form.userId" placeholder="用户ID" /></el-form-item>
      <el-form-item label="标题" prop="title"><el-input v-model="form.title" placeholder="标题" /></el-form-item>
      <el-form-item label="内容" prop="content"><el-input type="textarea" :rows="3" v-model="form.content" placeholder="内容" /></el-form-item>
      <el-form-item label="心情" prop="moodLabel"><el-input v-model="form.moodLabel" placeholder="心情" /></el-form-item>
      <el-form-item label="心情值" prop="moodValue"><el-input v-model="form.moodValue" placeholder="心情值" /></el-form-item>
      <el-form-item label="图标" prop="moodIcon"><el-input v-model="form.moodIcon" placeholder="图标" /></el-form-item>
      <el-form-item label="天气" prop="weather"><el-input v-model="form.weather" placeholder="天气" /></el-form-item>
      <el-form-item label="温度" prop="temperature"><el-input v-model="form.temperature" placeholder="温度" /></el-form-item>
      <el-form-item label="地区" prop="region"><el-input v-model="form.region" placeholder="地区" /></el-form-item>
      <el-form-item label="城市" prop="city"><el-input v-model="form.city" placeholder="城市" /></el-form-item>
      <el-form-item label="金句" prop="aiQuote"><el-input type="textarea" :rows="3" v-model="form.aiQuote" placeholder="金句" /></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operaprivateDiaryWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, userId: '', title: '', content: '', moodLabel: '', moodValue: '', moodIcon: '', weather: '', temperature: '', region: '', city: '', aiQuote: '' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/privateDiary', 'field.id': 'id' }) }
}
</script>